<template>
    <div
        class="modal fade"
        :id="id"
    >
        <div class="modal-dialog modal-dialog-centered modal-lg">
            <div class="modal-content">
            <div class="modal-header bg-transparent">
                <button
                    id="deactivateAccountClose"
                    type="button"
                    class="close"
                    data-dismiss="modal"
                    aria-label="Close"
                    v-on:click="emptyForm()"
                >
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body pb-5 px-sm-5 mx-50">
                <h4 style="margin-bottom: 20px;"  v-if="userStore.deactivate_type == userStore.DEACTIVATE_ACCOUNT">Deactivate Account.</h4>
                <h4 style="margin-bottom: 20px;" v-else>Cancel My Subscription.</h4>
                <div class="col-md-12">
                    <div class="col-md-12 col-sm-12" v-if="userStore.deactivate_type !== userStore.DEACTIVATE_ACCOUNT">
                        Please help us improve by sharing your reason for leaving <sup class="text-danger">(Required)</sup>
                    </div>
                    <div class="" v-if="userStore.deactivate_type == userStore.DEACTIVATE_ACCOUNT">
                        <p> 
                            When you <span class="text-primary " style="font-weight:bolder">DEACTIVATE your account</span>, your profile, account info, dispute letters, 
                            file-uploads and credit reports will be permanently removed. <span class="text-primary" style="font-weight:bolder">Optionally</span>, you can also choose to <span class="text-primary" style="font-weight:bolder">CANCEL</span> your subscription to take a break instead. 
                        </p>
                    </div>
                    <div class="col-md-6 col-sm-12 mt-2" v-else>
                        <div class="form-group" v-for="(reason,index) in userStore.deactivate_reasons" >
                            <div class="reasons_list_container" v-if="reason && reason.type == 1" >
                                <div class="reasons_list_inner_container">
                                    <div class="reasons_list_radio" ref="reasons_list" v-on:click="selectReason($event,reason.reason)"></div>
                                    <div class="reason_content">{{reason.reason}}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="form-group">
                        <label for="reasonfordeactivate">How likely are you to reactivate your Creditfixrr plan?.</label>
                        <div class="circle-rating">
                            <div class="rating" v-for="(value,index)  in rating_values">
                                <div class="rating-value" v-on:click="setRatingValueAndBackground($event,value)" ref="rating_elements"></div>
                                <div class="rating-content">
                                    {{value}}
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="form-group">
                        <label for="reasonfordeactivate">If there's anything else you would like to add about your Creditfixrr experience please comment here.</label>
                        <input type="text" class="form-control" placeholder="Start typing..." name="deactivate_user_comment" id="deactivate_user_comment" v-model="deactivate_user_comment">
                    </div>

                    <div class="form-group" v-if="userStore.deactivate_type == userStore.DEACTIVATE_ACCOUNT">
                        <p class="text-danger text-sm">(Required)</p>
                        <label for="reasonfordeactivate">Please type <b>{{userStore.deactivate_confirm_text}}</b> to confirm.</label>
                        <input type="text" class="form-control" placeholder="DEACTIVATE" name="deactivate_user_comment" id="deactivate_user_comment" v-model="deactivate">
                    </div>
                    <div class="form-group" v-else>
                        <p class="text-danger text-sm">(Required)</p>
                        <div class="custom-control custom-checkbox">
                            <input class="custom-control-input" id="cancel_plan" type="checkbox" tabindex="3" v-model="cancel_plan"/>
                            <label class="custom-control-label" for="cancel_plan"> I understand that by proceeding, I will loose access to all paid creditfixrr Feature at the end of my billing cycle.</label>
                        </div>
                    </div>

                </div>
                <div class="col-12 d-flex flex-sm-row flex-column mt-2" v-if="userStore.deactivate_type == userStore.DEACTIVATE_ACCOUNT">
                    <button type="submit" class="btn btn-primary mb-1 mb-sm-0 mr-0 mr-sm-1" v-on:click="deactivateAccount">Deactivate Account</button>
                    <button id="deactivateAccountClose" type="button" class="btn btn-outline-primary waves-effect" data-dismiss="modal" aria-label="Close" v-on:click="emptyForm()">Go Back</button>
                </div>
                <div class="col-12 d-flex flex-sm-row flex-column mt-2" v-else>
                    <button type="submit" class="btn btn-primary mb-1 mb-sm-0 mr-0 mr-sm-1" v-on:click="deactivateAccount">Yes, Cancel Subscription</button>
                    <button id="deactivateAccountClose" type="button" class="btn btn-outline-primary waves-effect" data-dismiss="modal" aria-label="Close" v-on:click="emptyForm()">Go Back</button>
                </div>
            </div>
            </div>
        </div>
    </div>
</template>
<script>
import { ref } from 'vue'
import { useBillingStore } from '../../stores/BillingStore.js'
import { useUserStore } from '../../stores/UserStore'
import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css';
export default{
    components:{
        vSelect
    },
    props: {
        id: String
    },
    setup(){
        return{
            reasons:ref(),
            reasons_list:ref(),
            reasonfordeactivate:ref(),
            deactivate_user_comment:ref(),
            billingStore: useBillingStore(),
            userStore:useUserStore(),
            deactivate_reasons_2:ref([]),
            deactivate_reason_2:ref(),
            rating_values:[1,2,3,4,5,6,7,8,9,10],
            reactivate_account_rating:ref(),
            rating_elements:ref(),
            cancel_plan:ref(false),
            deactivate:ref()
        }
    },
    watch: {
        'userStore.deactivate_reasons'(value) {
            this.filterDeactivateReasonTwo(value);
        },
    },
    mounted(){
        this.userStore.fetchDeactivateReasons();
    },
    methods:{
        deactivateAccount(){
            let params = {
                deactivate_reason : this.reasonfordeactivate,
                deactivate_reason_2 : this.deactivate_reason_2,
                reactivate_account_rating : this.reactivate_account_rating,
                deactivate_user_comment : this.deactivate_user_comment,
                deactivate_type : this.userStore.deactivate_type,
            },$this;
            if(this.cancel_plan){
                params.deactivate_reason_2 = 'Cancel Subscription';
                this.sendDeactivateRequest(params);
            }else if(!_.isEmpty(this.deactivate) && this.deactivate == this.userStore.deactivate_confirm_text){
                params.deactivate_reason = 'Delete My Account';
                params.deactivate_reason_2 = 'Deactivated Account';
                this.sendDeactivateRequest(params);
            }else{
                toastr.error('Pleace check the required fields and try again.','error');
            }
        },
        sendDeactivateRequest(params){
            const route = this.$router.resolve(
                {
                    name: 'deactivate-reasons',
                }
            ),
            homeRoute = this.$router.resolve(
                {
                    name: 'landing-page',
                }
            ),
            $this = this; 

            axios.post(route.href,params).then(({data})=>{
                if(data.error != true){
                    if(data.data.type == $this.userStore.CANCEL_SUBSCRIPTION){
                        $this.emptyForm();
                        return $this.billingStore.cancelSubscription($this.billingStore.CANCEL_SUBSCRIPTION);
                    }
                    window.location.href = homeRoute.href;
                    return toastr.success(data.message,'success');
                }
                return toastr.error(data.message,'Error');

            }).catch(error=>{
                toastr.error('An error occured please try again or contact support.','error');
            });
        },
        filterDeactivateReasonTwo(object){
            object.forEach(element => {
                if(element.type == this.userStore.DEACTIVATE_REASON_2){
                    this.deactivate_reasons_2.push(element);
                }
            });
        },
        setRatingValueAndBackground(e,value){
            this.reactivate_account_rating = value
            const rating_elements = this.$refs['rating_elements'],
            selectedDiv = e.target;
            // set all rating elements ref to default background and border
            this.unselectReasons('rating_elements');
            // Highlight all elements before the selected target to
            for (let index = 0; index < value; index++) {
                const element = rating_elements[index];
                if(index < value){
                    element.style.backgroundColor = '#4c9b5f';
                }
            }
            // highlight the selected target to
            selectedDiv.style.backgroundColor = '#4c9b5f';
        },
        selectReason(e,reason_value){
            this.reasonfordeactivate = reason_value
            let selectedTarget = e.target;
            // set all rating elements ref to default background and border
            this.unselectReasons('reasons_list');
            selectedTarget.style.backgroundColor = '#4c9b5f';

        },
        unselectReasons(refsList){
            const reasons = this.$refs[refsList];
            reasons.forEach(element => {
                element.style.backgroundColor = 'white';
                element.style.border = '1px solid green';
            });
        },
        emptyForm(){
            this.reasonfordeactivate = 0;
            this.deactivate_reason_2 = "";
            this.reactivate_account_rating = 0;
            this.deactivate_user_comment = "";
            this.unselectReasons('rating_elements');
            this.unselectReasons('reasons_list');
            
        }
    }
}
</script>
<style>
.circle-rating {
    position: relative;
}
.circle-rating .rating {
    display: inline-block;
}
.circle-rating .rating .rating-value {
    height: 30px;
    width: 30px;
    /* background: silver; */
    border-radius: 100%;
    border: 1px solid green;
    margin-right: 11px;
    margin-top: 9px;
    cursor: pointer;
}
.circle-rating .rating .rating-value:hover{
    background:green;
}
.circle-rating .rating .rating-content {
    height: 30px;
    width: 30px;
    text-align: center;
}
.reasons_list_container {
    position: relative;
    display: block;
}
.reasons_list_inner_container {
    display: inline-flex;
}
.reasons_list_radio {
    background: white;
    height: 15px;
    width: 15px;
    border-radius: 50%;
    border: 1px solid green;
    margin-right: 8px;
    cursor:pointer;
}
.reason_content {
    line-height: 15px;
}
</style>
